<template>
  <Container type="card-full" drankColor>
    <!-- <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div> -->
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable></el-input>
          </div>
        </div>
        <!-- <div class="searchItem">
          <div class="label">平台编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectno" clearable></el-input>
          </div>
        </div> -->
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">采购人</div>
          <div class="field">
            <el-input v-model.trim="query.comname" clearable></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">状态</div>
          <div class="field">
            <el-select v-model="query.status" :clearable="true" placeholder="请选择">
              <el-option
                v-for="item in projectStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button type='primary' @click="search">查询</el-button>
            <el-button
              v-if="+query.comtype === 1"
              type="primary"
              @click="showButton = !showButton"
              >{{ showButton ? "收起" : "展开" }}</el-button>
          </div>
        </div>
        <el-collapse-transition v-if="+query.comtype === 1">
          <div v-show="showButton">
            <el-radio-group v-model="areaid" @change="getPageList">
              <el-radio-button
                v-for="item in this.areaList"
                :key="item.dptareacode"
                :label="item.dptareacode"
                >{{ item.label }}</el-radio-button
              >
            </el-radio-group>
          </div>
        </el-collapse-transition>
      </div>
    </div>
    <div>
    </div>
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols"
            :showfooter="false" :showPage="true" :resizable="true"
            :total="query.total" @cellClick="cellClick" @cellDblClick="viewProject" @pagechange="pagechange"
            :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import moment from 'moment'
  import vggrid from '../common/vggrid'
  // import utils from '../../assets/js/utils'
  export default {
    name: 'bidOpening',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        btnLoading: false,
        showButton: true,
        areaList: [],
        areaid: 0, //查询地区id
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 50 },
          { field: 'projectcode', fieldtype: 'C', title: '项目编号',calculExpr:'',addNewRowFlg: false, width: 150},
          // { field: 'projectno', fieldtype: 'C', title: '平台编号',calculExpr:'',addNewRowFlg: false, width: 150},
          { field: 'projectname', fieldtype: 'C', title: '项目名称',calculExpr:'',addNewRowFlg: false},
          { field: 'comfullname', fieldtype: 'C', title: '采购人',calculExpr:'',addNewRowFlg: false},
          // { field: 'dailiname', fieldtype: 'C', title: '代理人',calculExpr:'',addNewRowFlg: false},
          // { field: 'prsflgdesc', fieldtype: 'C', title: '交易方式',calculExpr:'',addNewRowFlg: false, width: 80},
          // { field: 'projectisinviteCN', fieldtype: 'C', title: '报名方式',calculExpr:'',addNewRowFlg: false, width: 80},
          { field: 'projectstatusname', fieldtype: 'C', title: '状态',calculExpr:'',addNewRowFlg: false, width: 80},
          { field: 'projectopenbidmodedesc', fieldtype: 'C', title: '开标方式',calculExpr:'',addNewRowFlg: false, width: 80},
          { field: 'projectrecusername', fieldtype: 'C', title: '建项人',calculExpr:'',addNewRowFlg: false, width: 80},
          { field: 'prsbjbegtime', fieldtype: 'T', title: '开标开始时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', ''], width: 150},
          // { title: '操作 ', width: 160, showOverflow: true,
          //   slots: {
          //     default: 'default',
          //     default: ({row}) => {
          //       if(+row.prsflg === 1){
          //         return [<vxe-button onClick={this.showdownFild.bind(this, row)}>竞价附件</vxe-button>]
          //       }
          //       else if(+row.prsflg === 2){
          //         return [<vxe-button onClick={this.showdownFild.bind(this, row)}>招标附件</vxe-button>]
          //       }
          //     }
          //   }
          // },
        ],
        project: {},
        projectStatusList: [],
        query: {
          cosid: this.$store.getters.loginUser.cosid,
          userid: this.$store.getters.loginUser.userid,
          comid: this.$store.getters.loginUser.comid,
          comtype: this.$store.getters.loginUser.comtype,
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
    },
    activated() {
      this.init()
      this.TBJJbtn()
      this.getPageList()
      this.getProjectStatusList()
      if (this.query.comtype === 1) {
        this.getareaList();
      }
    },
    mounted () {
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      async getProjectStatusList () {
        this.projectStatusList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'projectstatus'}
        })
      },
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.project = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async init() {
        this.list = []
        this.btnLoading = false
        this.project = {}
        this.areaList = []
      },
    //获取地区list
    async getareaList() {
      let res = await request({
        method: "get",
        url: "/xtgl/dpt/getDptareaList",
        params: { cosid: this.$store.getters.loginUser.cosid },
      });
      this.areaList = res.filter((e) => {
        return +e.dptareause === 1;
      });
      this.areaList.unshift({
        dptareacode: 0,
        label: "全部",
      });
    },
      async projectAnnouncement(name,wmenudatawhere){
        if (!this.project.projectid) {
          this.$message.warning('请选择一个项目!')
          return
        }
        let wmenu = await request({
          method:'get',
          url:'/ywgl/wmenu/getWmenuId',
          params:{ wmenudatawhere: wmenudatawhere }
        })
        let form = {
          project:this.project,
          pjnoticefromid: this.project.projectid,
          wmenuid:wmenu[0].wmenuid,
          wmenuname: name,
          wmenudatawhere: wmenudatawhere
        }
        this.$router.push({name: 'pjnoticeIndex', params: {form: form}})
      },
      async TBJJbtn(){
        //供应商进去操作列表
          let nowdate = await request ({
            method: 'get',
            url: 'xtgl/sysdata'
          })
          if (this.cols[this.cols.length - 1].title == '操作 ' && !this.btn.isOperate) this.cols.pop()
          this.cols.push({ title: '操作 ', width: 100, showOverflow: true,
            slots: {
              default: ({row}) => {
                if(new Date(row.projectjkactualendtime).getTime() <= new Date(nowdate).getTime() && row.projectjkactualendtime != null){
                    return [<vxe-button type='primary' onClick={this.gobidOpeningView.bind(this,row)}>查看</vxe-button>]
                }
                if(new Date(row.prsbjendtime).getTime() > new Date(nowdate).getTime()){
                      if(row.psuid){
                          if(new Date(nowdate).getTime() < new Date(row.prsbjbegtime).getTime() && +row.projecttenderbidmode === 1){
                            return [<vxe-button type='primary' onClick={this.goOnlineTB.bind(this,row)}>投标</vxe-button>]
                          }
                          else if(new Date(nowdate).getTime() > new Date(row.prsbjbegtime).getTime() && +row.projectopenbidmode === 2){
                            return [<vxe-button type='primary' onClick={this.goJJorTB.bind(this,row)}>开标大厅</vxe-button>]
                          }
                          else{
                            return [<vxe-button type='primary' onClick={this.gobidOpeningView.bind(this,row)}>查看</vxe-button>]
                          }
                      }
                      else{
                          return [<vxe-button type='primary' onClick={this.goJJorTB.bind(this,row)}>开标大厅</vxe-button>]
                      }
                }
                else {
                  return [<vxe-button type='primary' onClick={this.gobidOpeningView.bind(this,row)}>查看</vxe-button>]
                }
              }}
          })
      },
      async gobidOpeningView(row){
        this.project = row
        if(row.projectjkactualendtime == null && +row.projectopenbidmode === 1){
          this.$message.warning('该项目为现场开标，请到达开标现场进行开标，开标结束后可查看')
          return
        }
        this.$router.push({name: 'bidOpeningView', params: {project: this.project, type: 1}})
      },
      async goJJorTB(row){
        this.project = row
        if(this.project.psuid){
          let res = await request({
            method: 'get',
            url: '/xmgl/bidOpening/getPsuByprojectId',
            params: {projectid: this.project.projectid,comid:this.$store.getters.loginUser.comid,}
          })
          if(+res.list[0].projectbmamt > 0){
            if(+res.list[0].psubmpaytype === 0){
              this.$message.warning('还未支付报名费')
              return
            }
            if(+res.list[0].psubmpayflg !== 1){
              this.$message.warning('报名费未确认')
              return
            }
          }
          if(+res.list[0].projectbzjamt > 0){
            if(+res.list[0].psubzjpaytype === 0){
              this.$message.warning('还未支付保证金')
              return
            }
            if(+res.list[0].psubzjpayflg !== 1){
              this.$message.warning('保证金未确认')
              return
            }
          }
        }
        if(moment(new Date().getTime()+0.5*3600*1000).isBefore(this.project.prsbjbegtime)){
          this.$message.warning('未到开标开始时间')
          return
        }
        this.$router.push({name: 'pbrTenderForm', params: {projectid: this.project.projectid,psuid:this.project.psuid,innerbtn: this.btn.inner}})
      },
      async goOnlineTB(row){
        this.project = row
        if(this.project.psuid){
          let res = await request({
            method: 'get',
            url: '/xmgl/project/getPsuListByComId',
            params: {projectid: this.project.projectid,
            comid:this.$store.getters.loginUser.comid,
            cosid:this.$store.getters.loginUser.cosid,
            offset: 0,limit: 1,}
          })
          if(res.list[0].projectbmamt > 0){
            if(+res.list[0].psubmpaytype === 0){
              this.$message.warning('还未支付报名费')
              return
            }
            if(+res.list[0].psubmpayflg !== 1){
              this.$message.warning('报名费未确认')
              return
            }
          }
          if(res.list[0].projectbzjamt > 0){
              if(+res.list[0].psubzjpaytype === 0){
              this.$message.warning('还未支付保证金')
              return
            }
            if(+res.list[0].psubzjpayflg !== 1){
              this.$message.warning('保证金未确认')
              return
            }
          }
        }
        this.$router.push({name: 'onlineBidding', params: {projectid: this.project.projectid,psuid:this.project.psuid, type: 1}})

      },
      async viewProject(row) {
        this.project = row.row
        if(this.project.psuid){
          this.$router.push({name: 'projectView', params: {projectid: this.project.projectid,psuid:this.project.psuid,innerbtn: this.btn.inner}})
        }
        else{
          this.$router.push({name: 'projectView', params: {projectid: this.project.projectid,innerbtn: this.btn.inner}})
        }
      },
      async cellClick (row) {
        this.project = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        this.query.cosid = this.$store.getters.loginUser.cosid
        this.query.areaid = this.areaid;
        this.query.isJJorTB = 2
        let res
        if(+this.query.comtype === 3){
          res = await request({
            method: 'get',
            url: '/xmgl/project/getPsuListByComId',
            params: this.query
          })
        }
        else{
            res = await request({
              method: 'get',
              url: '/xmgl/project/getPageList',
              params: this.query
            })
        }
        this.list = res.list
        res.list.forEach(e => {
          e.projectisinviteCN = +e.projectisinvite === 1 ? '邀请':'公开'
          e.projectopenbidmodedesc = +e.projectopenbidmode === 1? '现场开标':'远程开标'

        });
        this.query.total = res.count[0].count
        this.loading = false
      }
    }
  }
</script>
<style lang="scss">
</style>
